export var noop = function noop() {
  return;
};
export var noopPromise = function noopPromise() {
  return Promise.reject();
};